module.exports = __webpack_public_path__ + "static/media/icon-expand-dash.d09b1454.svg";